export const GET_SINGLE = 'getSingle'
export const GET_LIST = 'getList'
export const CREATE = 'createSingle'
export const UPDATE = 'updateSingle'
export const DELETE = 'deleteSingle'
export const FETCH_TYPES = 'fetchTypes'
export const FETCH_METAS = 'fetchMetas'
export const CHANGE_PASSWORD = 'changePassword'
export const CHECK_AUTH = 'checkAuth'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const FETCH_STATS = 'fetchStatistics'
export const RECOVERY = 'passwordRecovery'
export const VERIFY_TOKEN = 'verifyToken'
